"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletChannel = void 0;
const topic_1 = require("../../topic");
const WALLET_CHANNEL = 'wallet';
class WalletChannel {
    constructor(_logger) {
        this._logger = _logger;
        this.channel = WALLET_CHANNEL;
        this.topics = {
            PlayerAction_BetSucceeded: new topic_1.Topic('PlayerAction_BetSucceeded', WALLET_CHANNEL, this._logger),
            BalanceUpdated: new topic_1.Topic('BalanceUpdated', WALLET_CHANNEL, this._logger),
            BankrollUpdate: new topic_1.Topic('BankrollUpdate', WALLET_CHANNEL, this._logger),
            UpdateBalance: new topic_1.Topic('UpdateBalance', WALLET_CHANNEL, this._logger),
        };
    }
}
exports.WalletChannel = WalletChannel;
//# sourceMappingURL=wallet.channel.js.map